/* State of Sweet — site behavior: loader, smooth scroll, cursor, magnetic, reveals, flavor showcase */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------- Loader ---------- */
  var loader = document.querySelector('.loader');
  function dismissLoader(fast) {
    if (!loader || loader.classList.contains('away')) return;
    loader.classList.add(fast ? 'away' : 'resolve');
    if (!fast) setTimeout(function () { loader.classList.add('away'); }, 950);
    setTimeout(function () { loader.remove(); }, fast ? 800 : 1900);
    try { sessionStorage.setItem('sos-loaded', '1'); } catch (e) {}
  }
  if (loader) {
    var seen = false;
    try { seen = sessionStorage.getItem('sos-loaded') === '1'; } catch (e) {}
    if (reduced || seen) {
      dismissLoader(true);
    } else {
      requestAnimationFrame(function () { loader.classList.add('play'); });
      setTimeout(function () { dismissLoader(false); }, 1550);
      loader.querySelector('.skip').addEventListener('click', function () { dismissLoader(true); });
    }
  }

  /* ---------- Smooth momentum scroll (desktop wheel only) ---------- */
  if (!reduced && finePointer) {
    var target = window.scrollY, current = window.scrollY, raf = null, native = false;
    function maxScroll() { return document.documentElement.scrollHeight - window.innerHeight; }
    function loop() {
      current += (target - current) * 0.085;
      if (Math.abs(target - current) < 0.6) { current = target; raf = null; } else { raf = requestAnimationFrame(loop); }
      native = true; window.scrollTo(0, current); native = false;
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      e.preventDefault();
      target = Math.max(0, Math.min(maxScroll(), target + e.deltaY));
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: false });
    window.addEventListener('scroll', function () {
      if (!native && !raf) { target = current = window.scrollY; }
    }, { passive: true });
    /* Anchor links route through the smooth scroller */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var el = document.querySelector(a.getAttribute('href'));
      if (!el) return;
      e.preventDefault();
      target = Math.max(0, Math.min(maxScroll(), el.getBoundingClientRect().top + window.scrollY));
      if (!raf) raf = requestAnimationFrame(loop);
    });
  }

  /* ---------- Nav background on scroll ---------- */
  var nav = document.querySelector('.nav');
  window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });

  /* ---------- Custom cursor ---------- */
  if (finePointer && !reduced) {
    var cursor = document.querySelector('.cursor');
    var cx = -100, cy = -100, px = -100, py = -100;
    document.addEventListener('mousemove', function (e) { cx = e.clientX; cy = e.clientY; });
    (function cloop() {
      px += (cx - px) * 0.22; py += (cy - py) * 0.22;
      cursor.style.transform = 'translate(' + px + 'px,' + py + 'px)';
      requestAnimationFrame(cloop);
    })();
    document.addEventListener('mouseover', function (e) {
      cursor.classList.toggle('on-link', !!e.target.closest('a, button, summary, .fl-tab'));
    });
  }

  /* ---------- Magnetic buttons ---------- */
  if (finePointer && !reduced) {
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + dx * 0.18 + 'px,' + dy * 0.3 + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform 0.4s cubic-bezier(0.2, 0.9, 0.3, 1.3)';
        el.style.transform = '';
        setTimeout(function () { el.style.transition = ''; }, 400);
      });
    });
  }

  /* ---------- Scroll reveals ---------- */
  var ioFired = false;
  var io = new IntersectionObserver(function (entries) {
    ioFired = true;
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.rv, .rv-morse').forEach(function (el) { io.observe(el); });
  /* Some embedded webviews never deliver IO callbacks — fail open, never blank. */
  setTimeout(function () {
    if (!ioFired) document.documentElement.classList.add('no-reveal');
  }, 700);

  /* ---------- Flavor showcase ---------- */
  var FLAVORS = window.SOS_SITE_FLAVORS;
  var show = document.querySelector('.flavors');
  if (show && FLAVORS) {
    var stickyEl = show.querySelector('.sticky');
    var nameEl = show.querySelector('.fl-name');
    var blurbEl = show.querySelector('.fl-blurb');
    var numEl = show.querySelector('.fl-num');
    var linkEl = show.querySelector('.fl-link');
    var figs = show.querySelectorAll('.fl-can figure');
    var tabs = show.querySelectorAll('.fl-tab');
    var idx = -1, pending = null;

    function setName(text) {
      nameEl.classList.add('out');
      setTimeout(function () {
        nameEl.innerHTML = text.split(' ').map(function (w, i) {
          return '<span class="ln"><span style="--d:' + (i * 0.07) + 's">' + w + '</span></span>';
        }).join('');
        requestAnimationFrame(function () { requestAnimationFrame(function () { nameEl.classList.remove('out'); }); });
      }, 240);
    }

    function go(i, instant) {
      if (i === idx) return;
      idx = i;
      var f = FLAVORS[i];
      stickyEl.style.setProperty('--fl', f.color);
      figs.forEach(function (fg, j) { fg.classList.toggle('on', j === i); });
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      numEl.textContent = '0' + (i + 1) + ' / 04';
      blurbEl.textContent = f.blurb;
      linkEl.href = f.file || ('State of Sweet — Flavor.html?flavor=' + f.key);
      if (instant) {
        nameEl.innerHTML = '<span class="ln"><span>' + f.name.replace(/ /g, '</span></span> <span class="ln"><span>') + '</span></span>';
      } else { setName(f.name); }
    }

    var mobile = window.matchMedia('(max-width: 820px)').matches;
    if (!mobile) {
      window.addEventListener('scroll', function () {
        var r = show.getBoundingClientRect();
        var span = show.offsetHeight - window.innerHeight;
        var p = Math.max(0, Math.min(0.999, -r.top / span));
        go(Math.floor(p * 4), false);
      }, { passive: true });
    }
    tabs.forEach(function (t, j) {
      t.addEventListener('click', function () {
        if (mobile) { go(j, false); return; }
        var span = show.offsetHeight - window.innerHeight;
        var y = show.offsetTop + span * (j / 4 + 0.13);
        window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
        go(j, false);
      });
    });
    go(0, true);
  }
})();
